import CityPage from '../../components/CityPage';

const cityData = {
    name: "Tourgéville",
    slug: "tourgeville",
    postalCode: "14800",
    intro: "Situé à quelques minutes de Deauville, Tourgéville bénéficie du service de débarras professionnel de CC Débarras 14. Successions, ventes immobilières, déménagements ou simples encombrants : nous intervenons à Tourgéville pour tous types de débarras, dans les maisons, appartements, caves et dépendances. Une équipe réactive et sérieuse, pour un débarras gratuit sous conditions.",
    nearby: ["Deauville", "Touques", "Saint-Arnoult", "Blonville-sur-Mer", "Bénerville-sur-Mer"],
};

const Tourgeville = () => <CityPage city={cityData} />;

export default Tourgeville;
